enum FormBlockTypeEnum {
  BLOCK = 'block',
  DELIMITER = 'delimiter',
}

export default FormBlockTypeEnum;
